exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Link {\n  color: #0FACCF;\n  font-weight: 400; }\n", ""]);

